"use strict";

// A sample component

const Form = {
  init: function() {
    if (document.querySelector(".c-form_submit")) {
      Form.bloc = document.querySelector(".c-form_containerForm");
      Form.submit = document.querySelector(".c-form_submit");
      this.constructor();
      if (Form.submit) {
        Form.submit.addEventListener("click", (e) => {
          e.preventDefault();
          this.formSubmit();
        });
      }
    }
  },
  constructor() {
    this.address = document.querySelector('input[name="address"]');
    this.radioType = document.querySelectorAll('input[name="type_residence"]');
    this.birthdate = document.querySelector('input[name="birthdate"]');
    this.city = document.querySelector('input[name="city"]');
    this.email = document.querySelector('input[name="email"]');
    this.first_name = document.querySelector('input[name="first_name"]');
    this.formation = document.querySelector('input[name="formation"]');
    this.last_name = document.querySelector('input[name="last_name"]');
    this.phone = document.querySelector('input[name="phone"]');
    this.pitch = document.querySelector("#pitch");
    this.project_title = document.querySelector('input[name="project_title"]');
    this.zipcode = document.querySelector('input[name="zipcode"]');
    this.type_story = document.querySelector('input[name="type_story"]');
    this.type_residence = document.querySelector("#c-form_fieldResidence");
    this.is_use_blacklist = document.querySelector("#c-form_fieldBlacklist");
    this.country = document.querySelector('select[name="country"]');
    this.brief = document.querySelector('select[name="brief"]');
    this.optin_rgpd = document.querySelector("#optin_rgpd");
    this.g_recaptcha_response = document.querySelector("#g-recaptcha");
    this.file = document.querySelector('input[name="file"]');
    this.form = document.querySelector(".c-form_containerForm");
    this.formSend = document.querySelector(".c-form_worked");
    this.radioType.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        if (e.target.checked) {
          document
            .querySelectorAll("select[data-type]")
            .forEach((select) => (select.style.display = ""));
          document
            .querySelectorAll("select[data-type]")
            .forEach((select) => select.setAttribute("disabled", true));
          let select = document.querySelector(
            '[data-type="' + e.target.value + '"]'
          );
          if (select) {
            select.style.display = "block";
            select.removeAttribute("disabled");
            this.brief.classList.remove("c-form_brief--noChevron");
          }
        }
      });
    });
    const input = document.getElementById("file");
    const infoArea = document.getElementById("file-upload-filename");
    input.addEventListener("change", ShowFileName);
    function ShowFileName(e) {
      let input = e.srcElement;
      let fileName = input.files[0].name;
      infoArea.textContent = infoArea.getAttribute("data-msg") + " " + fileName;
    }
  },
  getAllDatas: function() {
    let formdata = new FormData(
      document.querySelector(".c-form_containerForm")
    );
    return formdata;
  },
  formSubmit: function() {
    var formdata = this.getAllDatas();
    var requestOptions = {
      method: "POST",
      body: formdata,
    };

    fetch(apiData.save_contact, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.code == "error_validation") {
          this.errorForm(result);
        }
        if (result.code == "all_good") {
          this.form.style.display = "none";
          this.formSend.style.display = "block";
        }
      });
  },
  errorForm: function(error) {
    const { data } = error;
    const { errors } = data;

    const {
      address,
      birthdate,
      brief,
      city,
      country,
      email,
      first_name,
      formation,
      is_alone_registration,
      is_use_blacklist,
      last_name,
      optin_rgpd,
      phone,
      pitch,
      project_title,
      type_residence,
      type_story,
      zipcode,
      file,
      g_recaptcha_response,
    } = errors;

    console.log(errors);
    console.log(g_recaptcha_response);
    console.log(this.g_recaptcha_response);
    console.log(this.optin_rgpd);
    address
      ? this.errors.inputText(this.address, address)
      : this.valid.inputText(this.address);
    birthdate
      ? this.errors.inputText(this.birthdate, birthdate)
      : this.valid.inputText(this.birthdate);
    city
      ? this.errors.inputText(this.city, city)
      : this.valid.inputText(this.city);
    email
      ? this.errors.inputText(this.email, email)
      : this.valid.inputText(this.email);
    first_name
      ? this.errors.inputText(this.first_name, first_name)
      : this.valid.inputText(this.first_name);
    formation
      ? this.errors.inputText(this.formation, formation)
      : this.valid.inputText(this.formation);
    last_name
      ? this.errors.inputText(this.last_name, last_name)
      : this.valid.inputText(this.last_name);
    phone
      ? this.errors.inputText(this.phone, phone)
      : this.valid.inputText(this.phone);
    pitch
      ? this.errors.inputText(this.pitch, pitch)
      : this.valid.inputText(this.pitch);
    project_title
      ? this.errors.inputText(this.project_title, project_title)
      : this.valid.inputText(this.project_title);
    zipcode
      ? this.errors.inputText(this.zipcode, zipcode)
      : this.valid.inputText(this.zipcode);
    type_story
      ? this.errors.inputText(this.type_story, type_story)
      : this.valid.inputText(this.type_story);
    type_residence
      ? this.errors.inputText(this.type_residence, type_residence)
      : this.valid.inputText(this.type_residence);
    is_use_blacklist
      ? this.errors.inputText(this.is_use_blacklist, is_use_blacklist)
      : this.valid.inputText(this.is_use_blacklist);
    country
      ? this.errors.inputText(this.country, country)
      : this.valid.inputText(this.country);
    brief
      ? this.errors.inputText(this.brief, brief)
      : this.valid.inputText(this.brief);
    optin_rgpd
      ? this.errors.inputText(this.optin_rgpd, optin_rgpd)
      : this.valid.inputText(this.optin_rgpd);
    file
      ? this.errors.inputText(this.file, file)
      : this.valid.inputText(this.file);
    g_recaptcha_response
      ? this.errors.inputText(this.g_recaptcha_response, g_recaptcha_response)
      : this.valid.inputText(this.g_recaptcha_response);
    grecaptcha.reset();
  },
  errors: {
    inputText(element, message) {
      element.parentElement.querySelector(".errorMessage").innerHTML = message;
      element.parentElement.classList.add("error");
      element.classList.add("error");
    },
  },
  valid: {
    inputText(element) {
      element.parentElement.querySelector(".errorMessage").innerHTML = "";
      element.parentElement.classList.remove("error");
      element.classList.remove("error");
    },
  },
};

export default Form;



// WEBPACK FOOTER //
// ./src/scripts/components/Form.js